import { STATUS_NAMES_EXCEPT_CANCELED } from '@core/consts';
import { clearEmptyProperties } from '@core/utils/filters-utils';
import { TranslateService } from '@ngx-translate/core';
import { chain, clone } from 'lodash';
import moment from 'moment';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var DeadlinesMapperService = /** @class */ (function () {
    function DeadlinesMapperService(translateService) {
        this.translateService = translateService;
        this.timelineOptions = {
            lastSevenDays: moment().subtract(6, 'days').startOf('day').utc().toISOString(),
            lastThirtyDays: moment().subtract(29, 'days').startOf('day').utc().toISOString(),
            lastNinetyDays: moment().subtract(89, 'days').startOf('day').utc().toISOString(),
            lastSixMonths: moment().subtract(5, 'months').startOf('day').utc().toISOString(),
            lastTwelveMonths: moment().subtract(11, 'months').startOf('day').utc().toISOString(),
        };
        this.columnsByTimelineOption = {
            lastSevenDays: 7,
            lastThirtyDays: 10,
            lastNinetyDays: 9,
            lastSixMonths: 6,
            lastTwelveMonths: 12,
        };
        moment.locale(this.translateService.currentLang || 'pt');
    }
    DeadlinesMapperService.prototype.toMaintenancesQueryParams = function (_a) {
        var where = _a.where, formValue = _a.formValue;
        var query = clone(where);
        var initialDate = formValue.initialDate, finalDate = formValue.finalDate, dateFilterType = formValue.dateFilterType;
        var mappedQuery = {
            status_in: STATUS_NAMES_EXCEPT_CANCELED.join(','),
            locationGroupId_in: query.locationGroupId_in && query.locationGroupId_in.join(','),
            locationId_in: query.locationId_in && query.locationId_in,
            typeId_in: query.maintenanceTypeId_in && query.maintenanceTypeId_in.join(','),
            segmentId_in: query.segmentId_in && query.segmentId_in.join(','),
            companyId_in: query.companyId_in && query.companyId_in.join(',')
        };
        mappedQuery[dateFilterType + "_gte"] = moment(initialDate).startOf('day').format('YYYY-MM-DD');
        mappedQuery[dateFilterType + "_lte"] = moment(finalDate).endOf('day').format('YYYY-MM-DD');
        return clearEmptyProperties(mappedQuery);
    };
    DeadlinesMapperService.prototype.toTimelineWhere = function (_a) {
        var where = _a.where, timelineOption = _a.timelineOption;
        var whereInput = clone(where);
        delete whereInput.closedAt_gte;
        delete whereInput.closedAt_lte;
        delete whereInput.scheduledAt_gte;
        delete whereInput.scheduledAt_lte;
        whereInput.openedAt_lte = moment().endOf('day').utc().toISOString();
        whereInput.openedAt_gte = this.timelineOptions[timelineOption];
        return whereInput;
    };
    DeadlinesMapperService.prototype.toTimeline = function (_a) {
        var type = _a.type, data = _a.data, timelineOption = _a.timelineOption;
        if (timelineOption === 'lastSevenDays') {
            return this.toTimelineLastSevenDays({ type: type, data: data });
        }
        if (timelineOption === 'lastThirtyDays' || timelineOption === 'lastNinetyDays') {
            var range = timelineOption === 'lastThirtyDays' ? 3 : 10;
            return this.toTimelineLastWithRangedDays({ type: type, data: data, range: range, timelineOption: timelineOption });
        }
        return this.toTimelineLastMonths({ type: type, data: data, timelineOption: timelineOption });
    };
    DeadlinesMapperService.prototype.toTimelineLastSevenDays = function (_a) {
        var type = _a.type, data = _a.data;
        var timeline = [];
        var _loop_1 = function (i) {
            var date = moment().subtract(i, 'days');
            var formattedDate = date.format('YYYY-MM-DD');
            var items = data.filter(function (_a) {
                var day = _a.day;
                return moment(day).isSame(formattedDate);
            });
            var series = this_1.toTimelineResponseSeries({ type: type, items: items });
            timeline.push({
                name: date.format('ddd DD/MM'),
                series: series,
            });
        };
        var this_1 = this;
        for (var i = 0; i < this.columnsByTimelineOption.lastSevenDays; i++) {
            _loop_1(i);
        }
        return timeline.reverse();
    };
    DeadlinesMapperService.prototype.toTimelineLastWithRangedDays = function (_a) {
        var type = _a.type, data = _a.data, range = _a.range, timelineOption = _a.timelineOption;
        var timeline = [];
        var firstDayOfSheet = this.timelineOptions[timelineOption];
        var _loop_2 = function (i) {
            var firstDay = moment(firstDayOfSheet).add(i * range, 'days').format('YYYY-MM-DD');
            var lastDay = moment(firstDay).add(range - 1, 'days').format('YYYY-MM-DD');
            var items = data.filter(function (_a) {
                var day = _a.day;
                return moment(day).isSameOrAfter(firstDay) && moment(day).isSameOrBefore(lastDay);
            });
            var series = this_2.toTimelineResponseSeries({ type: type, items: items });
            timeline.push({
                name: moment(firstDay).format('DD/MM') + " - " + moment(lastDay).format('DD/MM'),
                series: series,
            });
        };
        var this_2 = this;
        for (var i = 0; i < this.columnsByTimelineOption[timelineOption]; i++) {
            _loop_2(i);
        }
        return timeline;
    };
    DeadlinesMapperService.prototype.toTimelineLastMonths = function (_a) {
        var type = _a.type, data = _a.data, timelineOption = _a.timelineOption;
        var firstDayOfSheet = this.timelineOptions[timelineOption];
        var timeline = [];
        var _loop_3 = function (i) {
            var date = moment(firstDayOfSheet).add(i, 'months').format('YYYY-MM-DD');
            var items = data.filter(function (_a) {
                var day = _a.day;
                return moment(day).isSame(date, 'month');
            });
            var series = this_3.toTimelineResponseSeries({ type: type, items: items });
            timeline.push({
                name: moment(date).format('MMM YYYY'),
                series: series,
            });
        };
        var this_3 = this;
        for (var i = 0; i < this.columnsByTimelineOption[timelineOption]; i++) {
            _loop_3(i);
        }
        return timeline;
    };
    DeadlinesMapperService.prototype.toTimelineResponseSeries = function (_a) {
        var type = _a.type, items = _a.items;
        var onPeriodKey = type + "InPeriodCount";
        var outPeriodKey = type + "OutPeriodCount";
        var onPeriodCount = chain(items)
            .map(function (item) { return item[onPeriodKey]; })
            .sum()
            .value();
        var outPeriodCount = chain(items)
            .map(function (item) { return item[outPeriodKey]; })
            .sum()
            .value();
        return [
            {
                name: outPeriodKey,
                value: outPeriodCount,
                onPeriodCount: onPeriodCount,
                outPeriodCount: outPeriodCount,
            },
            {
                name: onPeriodKey,
                value: onPeriodCount,
                onPeriodCount: onPeriodCount,
                outPeriodCount: outPeriodCount,
            }
        ];
    };
    DeadlinesMapperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DeadlinesMapperService_Factory() { return new DeadlinesMapperService(i0.ɵɵinject(i1.TranslateService)); }, token: DeadlinesMapperService, providedIn: "root" });
    return DeadlinesMapperService;
}());
export { DeadlinesMapperService };
